(function (app) {
    app.provider("homeApi", [function () {
        this.$get = [
            "portalApiGateway", function (portalApiGateway) {
                var service = {};

                service.getUserInfo = function () {
                    return portalApiGateway.get("/Users/LoggedInUser");
                };

                service.getUserMarketingDollars = function () {
                    return portalApiGateway.get("/MarketingDollars/");
                };

                service.exportMarketingDollars = function () {
                    return portalApiGateway.getFile("/MarketingDollars/Export");
                };

                service.getUserFigAuth = function (userId) {
                    return portalApiGateway.get("/Users/" + userId + "/FigAuth/");
                };

                service.getUserCPCs = function (start, end) {
                    return portalApiGateway.get("/CPCs?start=" + start
                        + "&end=" + end);
                };
                return service;
            }
        ];
    }
    ]);
})(window.app);